import React from 'react'
import { FiShoppingCart } from 'react-icons/fi'
import { context, styled } from '@tools/wr-catalog-base'

function CartIndicator(props) {
  const { cart } = context.state
  return (
    <button className={props.className}>
      <FiShoppingCart size={20} />
      <span>{cart.length}</span>
    </button>
  )
}

export default styled(CartIndicator)`
  display: inline-block;
  color: white;
  position: relative;
  background: transparent;
  padding: 0;
  border: 0;
  margin: 0;

  width: 300px;
  display: flex;
  justify-content: center;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }

  span {
    display: inline-block;
    position: absolute;
    background: white;
    color: black;
    padding: 0 3px;
    font-size: 0.6em;
    border-radius: 2px;
    border: 1px solid #0008;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
  }
`
